import { useEffect, useState } from 'react';
import { postAbout } from '../utils/api';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const AboutModal = ({ open, onClose, accessToken, xml: initialXml }) => {
  const [xml, setXml] = useState('');

  useEffect(() => {
    setXml(initialXml || '');
  }, [open, initialXml]);

  const save = () => {
    if (xml) {
      postAbout(accessToken, xml)
      .then(() => {
        onClose();
      })
      .catch((error) => {
        console.warn(error);
        alert(error.toString());
      });
    }
  };

  return (
    <Dialog fullScreen={true} open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Change About</DialogTitle>
      <DialogContent>
        <TextField 
            autoFocus 
            margin="dense" 
            id="name" 
            label="Name" 
            type="text" 
            multiline={true} 
            fullWidth 
            value={xml} 
            onChange={(e) => setXml(e.target.value)} 
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={save} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutModal;